import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const categoriesTree: ThemeUICSSObject = {
  '.tree__leaf__label label': {
    display: 'flex',
    alignItems: 'center',
    py: 2,
    gap: spacing(3),
  },

  ul: {
    pl: spacing(7),
  },
  /* PREPEND HERE */
};

export default categoriesTree;
